import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, Dialog, DialogContent, IconButton } from "@mui/material";
import {
  DividerLine,
  DownloadButton,
  Heading,
  Subtitle,
  Title,
} from "./downloadCertificate.components";
import Certificate from "./certificate";

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <Heading {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 35,
            top: 20,
            color: "#000",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Heading>
  );
};

function DownloadCertificate({ internshipName, enrollDate, submissionDate, downloadCertificate, setDownloadCertificate }) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setDownloadCertificate(false);
  };

  return (
    <div>
      <Certificate open={open} setOpen={setOpen} internshipName={internshipName} enrollDate={enrollDate} submissionDate={submissionDate} />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={downloadCertificate}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Download Certificate
        </BootstrapDialogTitle>
        <DividerLine />
        <DialogContent sx={{ width: { md: 525 } }}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3.75}
          >
            <Title>Congratulation!</Title>
            <Subtitle>
              You have successfully completed your internship.
            </Subtitle>
            <DownloadButton onClick={() => { setDownloadCertificate(false); setOpen(true) }}>Download Certificate </DownloadButton>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default DownloadCertificate;
